import { formFieldsTable as formFields } from "./form-config";
import { BlockAvatar, ClickableActionNameCell, SimpleTextCell, LinkCell } from "./Components";
import { t } from "i18next";
import FormItem from "../../components/FormItem";
import { TextFilter } from "../../components/Filters/TextFilter";
import { AddressInputInbuilt } from "../../components/AddressInputInbuilt";
import { AdressesMultiCell } from "../ARMS/columns";

export const getColumns = ({ control, columnsFromStorage, writeSearchDataToSessionStorage, rows }) =>
  [
    {
      id: formFields.avatarLink,
      numeric: false,
      enableSorting: false,
      label: "",
      styleTableCell: {
        verticalAlign: "top",
      },
      clickable: false,
      isVisible: columnsFromStorage[formFields.avatarLink],
      RowCell: ({ row }) => <BlockAvatar data={row[formFields.avatarLink]} />,
    },
    {
      id: formFields.employeeFullName,
      numeric: false,
      enableSorting: false,
      label: t("label:FIO_employee"),
      styleTableCell: {
        verticalAlign: "top",
      },
      size: "150px",
      isVisible: columnsFromStorage[formFields.employeeFullName],
      RowCell: (props) => <ClickableActionNameCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.employeeFullName}`}
          sx={{ padding: "12px 0" }}
          placeholder={t("label:FIO_employee")}
          input={(props) => (
            <TextFilter
              className="select_in_built small-light"
              bgcolor={"var(--bgLightGrey)"}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchemployeeFullNameStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.employeeLogin,
      numeric: false,
      enableSorting: false,
      label: t("tableHeader:employeeLogin"),
      styleTableCell: {
        verticalAlign: "top",
      },
      size: "150px",
      isVisible: columnsFromStorage[formFields.employeeLogin] && !rows?.hideEmployeeLogin,
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.employeeLogin}`}
          sx={{ padding: "12px 0" }}
          placeholder={t("tableHeader:employeeLogin")}
          input={(props) => (
            <TextFilter
              className="select_in_built small-light"
              bgcolor={"var(--bgLightGrey)"}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchemployeeLoginStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: "phoneNumber",
      numeric: false,
      enableSorting: false,
      size: "150px",
      isVisible: true,
      RowCell: (props) => <LinkCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.employeePhoneNumber}`}
          placeholder={t("tableHeader:object_phone")}
          input={(props) => (
            <TextFilter
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchphoneNumberStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.subdivisionName,
      numeric: false,
      enableSorting: false,
      label: "Подразделение",
      size: "150px",
      isVisible: true,
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.subdivisionName}`}
          placeholder={"Выберите подразделение"}
          input={(props) => (
            <TextFilter
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchSubdivisionNameStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.subdivisionAddress,
      numeric: false,
      enableSorting: false,
      isVisible: true,
      clickable: false,
      RowCell: (props) => <AdressesMultiCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          placeholder={"Адрес подразделения"}
          name={`${formFields.searchParams}.${formFields.subdivisionAddress}`}
          input={(props) => (
            <AddressInputInbuilt
              {...props}
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchSubdivisionAddressStorage"
            />
          )}
        />
      ),
    },
    {
      id: formFields.edit,
      numeric: false,
      enableSorting: false,
      label: "",
      size: 50,
      isVisible: true,
      clickable: false,
    },
  ].filter(({ isVisible }) => isVisible);
